module.exports = __webpack_public_path__ + "./YiShan_945d99093f00f896c714116f40deaf96.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2020/YiShan.jpg
// module id = 512
// module chunks = 0